import React, { useMemo } from "react";
import { find, head } from "lodash";
import styled from "styled-components";
import { Spacing, dominant, form, transparentize } from "@glossy";
import Button from "@ui-kit/form/button";
import Icon from "@ui-kit/icon";
import Menu from "@ui-kit/popover/menu";

type Value = {
  id: string;
  label: string;
};

export interface DropdownProps {
  onSelect: (id: string) => any;
  selected: string;
  values: Value[];
  className?: string;
}

const getSelectedValue = (values: Value[], selected?: string): Value =>
  selected ? find(values, { id: selected }) : head(values);

const StyledButton = styled(Button)`
  width: auto;
  background-color: ${(props) => transparentize(0.85, form(props, "primary"))};
  :focus {
    box-shadow: none;
    background-color: ${(props) =>
      transparentize(0.85, form(props, "primary"))};
  }
  &[aria-expanded="true"] {
    box-shadow: 0 0 0 2px ${dominant} inset;
    background-color: transparent !important;
  }
`;

const StyledIcon = styled(Icon)`
  margin-left: ${Spacing.ExtraSmall};
`;

export function Dropdown({
  onSelect,
  selected,
  values,
  className,
}: DropdownProps) {
  const selectedValue = useMemo(() => getSelectedValue(values, selected), [
    selected,
    values,
  ]);
  return (
    <Menu
      disclosure={
        <StyledButton size="l" variant="primary" className={className}>
          <span>{selectedValue.label}</span>
          <StyledIcon glyph="chevron-small-down" size="ms" />
        </StyledButton>
      }
      values={values}
      onSelect={onSelect}
      selected={selected}
    />
  );
}
